module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/nose-d199d3f23b9489c32b2241f7a0af0dd0.png";